import { Directive, HostListener, Input } from "@angular/core";
import { Params, Router } from "@angular/router";
import { automataNavigatorFn } from "@shared/utils/router";

@Directive({
	selector: "[appAutomataNavigator]",
	standalone: true
})
export class AutomataNavigatorDirective {
	@Input() queryParams: Params | null | undefined = null;

	constructor(private router: Router) {}

	private isSelectableElement(target: EventTarget | null): boolean {
		if (target instanceof Element) {
			return target.hasAttribute("selectable");
		}
		return false;
	}

	@HostListener("click", ["$event"])
	onNavigate(e: Event): void {
		if (this.isSelectableElement(e.target)) {
			return;
		}
		const { routeToNavigate } = automataNavigatorFn(e);

		if (routeToNavigate) {
			if (this.queryParams) {
				void this.router.navigate([routeToNavigate], {
					queryParams: { ...this.queryParams },
					queryParamsHandling: "merge"
				});
				return;
			}
			void this.router.navigateByUrl(routeToNavigate);
		}
	}
}
